"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var items_1 = require("./items");
var views_1 = require("./views");
var contenttypes_1 = require("./contenttypes");
var fields_1 = require("./fields");
var forms_1 = require("./forms");
var subscriptions_1 = require("./subscriptions");
var queryable_1 = require("./queryable");
var queryablesecurable_1 = require("./queryablesecurable");
var util_1 = require("../../utils/util");
var usercustomactions_1 = require("./usercustomactions");
var odata_1 = require("./odata");
var Lists = (function (_super) {
    __extends(Lists, _super);
    function Lists(baseUrl, path) {
        if (path === void 0) { path = "lists"; }
        _super.call(this, baseUrl, path);
    }
    Lists.prototype.getByTitle = function (title) {
        return new List(this, "getByTitle('" + title + "')");
    };
    Lists.prototype.getById = function (id) {
        var list = new List(this);
        list.concat("('" + id + "')");
        return list;
    };
    Lists.prototype.add = function (title, description, template, enableContentTypes, additionalSettings) {
        var _this = this;
        if (description === void 0) { description = ""; }
        if (template === void 0) { template = 100; }
        if (enableContentTypes === void 0) { enableContentTypes = false; }
        if (additionalSettings === void 0) { additionalSettings = {}; }
        var postBody = JSON.stringify(util_1.Util.extend({
            "__metadata": { "type": "SP.List" },
            "AllowContentTypes": enableContentTypes,
            "BaseTemplate": template,
            "ContentTypesEnabled": enableContentTypes,
            "Description": description,
            "Title": title,
        }, additionalSettings));
        return this.post({ body: postBody }).then(function (data) {
            return { data: data, list: _this.getByTitle(title) };
        });
    };
    Lists.prototype.ensure = function (title, description, template, enableContentTypes, additionalSettings) {
        var _this = this;
        if (description === void 0) { description = ""; }
        if (template === void 0) { template = 100; }
        if (enableContentTypes === void 0) { enableContentTypes = false; }
        if (additionalSettings === void 0) { additionalSettings = {}; }
        if (this.hasBatch) {
            throw new Error("The ensure method is not supported as part of a batch.");
        }
        return new Promise(function (resolve, reject) {
            var list = _this.getByTitle(title);
            list.get().then(function (d) { return resolve({ created: false, data: d, list: list }); }).catch(function () {
                _this.add(title, description, template, enableContentTypes, additionalSettings).then(function (r) {
                    resolve({ created: true, data: r.data, list: _this.getByTitle(title) });
                });
            }).catch(function (e) { return reject(e); });
        });
    };
    Lists.prototype.ensureSiteAssetsLibrary = function () {
        var q = new Lists(this, "ensuresiteassetslibrary");
        return q.post().then(function (json) {
            return new List(odata_1.extractOdataId(json));
        });
    };
    Lists.prototype.ensureSitePagesLibrary = function () {
        var q = new Lists(this, "ensuresitepageslibrary");
        return q.post().then(function (json) {
            return new List(odata_1.extractOdataId(json));
        });
    };
    return Lists;
}(queryable_1.QueryableCollection));
exports.Lists = Lists;
var List = (function (_super) {
    __extends(List, _super);
    function List(baseUrl, path) {
        _super.call(this, baseUrl, path);
    }
    Object.defineProperty(List.prototype, "contentTypes", {
        get: function () {
            return new contenttypes_1.ContentTypes(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(List.prototype, "items", {
        get: function () {
            return new items_1.Items(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(List.prototype, "views", {
        get: function () {
            return new views_1.Views(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(List.prototype, "fields", {
        get: function () {
            return new fields_1.Fields(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(List.prototype, "forms", {
        get: function () {
            return new forms_1.Forms(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(List.prototype, "defaultView", {
        get: function () {
            return new queryable_1.QueryableInstance(this, "DefaultView");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(List.prototype, "userCustomActions", {
        get: function () {
            return new usercustomactions_1.UserCustomActions(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(List.prototype, "effectiveBasePermissions", {
        get: function () {
            return new queryable_1.Queryable(this, "EffectiveBasePermissions");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(List.prototype, "eventReceivers", {
        get: function () {
            return new queryable_1.QueryableCollection(this, "EventReceivers");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(List.prototype, "relatedFields", {
        get: function () {
            return new queryable_1.Queryable(this, "getRelatedFields");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(List.prototype, "informationRightsManagementSettings", {
        get: function () {
            return new queryable_1.Queryable(this, "InformationRightsManagementSettings");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(List.prototype, "subscriptions", {
        get: function () {
            return new subscriptions_1.Subscriptions(this);
        },
        enumerable: true,
        configurable: true
    });
    List.prototype.getView = function (viewId) {
        return new views_1.View(this, "getView('" + viewId + "')");
    };
    List.prototype.update = function (properties, eTag) {
        var _this = this;
        if (eTag === void 0) { eTag = "*"; }
        var postBody = JSON.stringify(util_1.Util.extend({
            "__metadata": { "type": "SP.List" },
        }, properties));
        return this.post({
            body: postBody,
            headers: {
                "IF-Match": eTag,
                "X-HTTP-Method": "MERGE",
            },
        }).then(function (data) {
            var retList = _this;
            if (properties.hasOwnProperty("Title")) {
                retList = _this.getParent(List, _this.parentUrl, "getByTitle('" + properties["Title"] + "')");
            }
            return {
                data: data,
                list: retList,
            };
        });
    };
    List.prototype.delete = function (eTag) {
        if (eTag === void 0) { eTag = "*"; }
        return this.post({
            headers: {
                "IF-Match": eTag,
                "X-HTTP-Method": "DELETE",
            },
        });
    };
    List.prototype.getChanges = function (query) {
        var postBody = JSON.stringify({ "query": util_1.Util.extend({ "__metadata": { "type": "SP.ChangeQuery" } }, query) });
        var q = new List(this, "getchanges");
        return q.post({ body: postBody });
    };
    List.prototype.getItemsByCAMLQuery = function (query) {
        var expands = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            expands[_i - 1] = arguments[_i];
        }
        var postBody = JSON.stringify({ "query": util_1.Util.extend({ "__metadata": { "type": "SP.CamlQuery" } }, query) });
        var q = new List(this, "getitems");
        q = q.expand.apply(q, expands);
        return q.post({ body: postBody });
    };
    List.prototype.getListItemChangesSinceToken = function (query) {
        var postBody = JSON.stringify({ "query": util_1.Util.extend({ "__metadata": { "type": "SP.ChangeLogItemQuery" } }, query) });
        var q = new List(this, "getlistitemchangessincetoken");
        return q.post({ body: postBody }, { parse: function (r) { return r.text(); } });
    };
    List.prototype.recycle = function () {
        this.append("recycle");
        return this.post().then(function (data) {
            if (data.hasOwnProperty("Recycle")) {
                return data.Recycle;
            }
            else {
                return data;
            }
        });
    };
    List.prototype.renderListData = function (viewXml) {
        var q = new List(this, "renderlistdata(@viewXml)");
        q.query.add("@viewXml", "'" + viewXml + "'");
        return q.post().then(function (data) {
            data = JSON.parse(data);
            if (data.hasOwnProperty("RenderListData")) {
                return data.RenderListData;
            }
            else {
                return data;
            }
        });
    };
    List.prototype.renderListFormData = function (itemId, formId, mode) {
        var q = new List(this, "renderlistformdata(itemid=" + itemId + ", formid='" + formId + "', mode=" + mode + ")");
        return q.post().then(function (data) {
            data = JSON.parse(data);
            if (data.hasOwnProperty("ListData")) {
                return data.ListData;
            }
            else {
                return data;
            }
        });
    };
    List.prototype.reserveListItemId = function () {
        var q = new List(this, "reservelistitemid");
        return q.post().then(function (data) {
            if (data.hasOwnProperty("ReserveListItemId")) {
                return data.ReserveListItemId;
            }
            else {
                return data;
            }
        });
    };
    return List;
}(queryablesecurable_1.QueryableSecurable));
exports.List = List;
